module.exports = __webpack_public_path__ + "static/img/zhangjiawei1.ec18354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhangjiawei1.png
// module id = nBWb
// module chunks = 1